export default "__VITE_ASSET__yuYZGU$9__"